// extracted by mini-css-extract-plugin
export default {"SectionContainer":"Overview-module__SectionContainer__QU5D3zt","TableFooter":"Overview-module__TableFooter__UWugGZT"};